export const whatAreCardsProductCards = [
	{
		icon: '💁‍♀️',
		subtitle: 'whatAreCardsData_subtitle1',
	},
	{
		icon: '📢',
		subtitle: 'whatAreCardsData_subtitle2',
	},
	{
		icon: '🤘',
		subtitle: 'whatAreCardsData_subtitle3',
	},
];
